// extracted by mini-css-extract-plugin
export default {"WrapperContenedor":"Reportes_WrapperContenedor__cZCMS","wrapperTable":"Reportes_wrapperTable__TIaiZ"};